const USER_TYPES = {
  member: "member",
  affiliate: "affiliate",
  student: "student",
  graduate: "graduate",
  firm: "firm",
};
export default USER_TYPES;
